"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleLogo = exports.StyleLink = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _responsive = _interopRequireDefault(require("webmotors-react-pj/tokens/responsive"));
const StyleLink = exports.StyleLink = _styledComponents.default.span.withConfig({
  displayName: "StyleLink",
  componentId: "sc-1v7cvld-0"
})(["max-width:115px;height:52px;line-height:50%;@media ", "{display:none;}"], _responsive.default.lg);
const StyleLogo = exports.StyleLogo = _styledComponents.default.img.withConfig({
  displayName: "StyleLogo",
  componentId: "sc-1v7cvld-1"
})(["width:112px;margin:14px 0px 14px 20px;display:block;@media ", "{width:200px;margin:20px 25px;}"], _responsive.default.lg);